import { useMarketContext } from '../contexts/MarketContext'

export default function useLanguage() {
  const { market } = useMarketContext()
  const { selectedLanguage } = market
  return selectedLanguage
}
